import { Routes } from '@angular/router';
import { AppMainComponent } from './main/app.main.component';
import { AppErrorComponent } from './pages/error/app.error.component';
import { AppLoginComponent } from './pages/login/app.login.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: AppMainComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./main/dashboard/dashboard.routes').then(
            (m) => m.DASHBOARD_ROUTES,
          ),
      },
      {
        path: 'dispositivo',
        loadChildren: () =>
          import('./main/cadastros/dispositivo/dispositivo.routes').then(
            (m) => m.DISPOSITIVO_ROUTES,
          ),
      },
      {
        path: 'usuario',
        loadChildren: () =>
          import('./main/cadastros/usuario/usuario.routes').then(
            (m) => m.USUARIO_ROUTES,
          ),
      },
      {
        path: 'permissao',
        loadChildren: () =>
          import('./main/cadastros/permissao/permissao.routes').then(
            (m) => m.PERMISSAO_ROUTES,
          ),
      },
      {
        path: 'administracao',
        loadChildren: () =>
          import('./main/administracao/administracao.routes').then(
            (m) => m.ADMINISTRACAO_ROUTES,
          ),
      },
      {
        path: 'tabelas',
        loadChildren: () =>
          import('./main/tabelas/tabela.routes').then((m) => m.TABELAS_ROUTES),
      },
      {
        path: 'contrato',
        loadChildren: () =>
          import('./main/contrato/contrato.routes').then(
            (m) => m.CONTRATO_ROUTES,
          ),
      },
      {
        path: 'faixa',
        loadChildren: () =>
          import('./main/faixa/faixa.routes').then((m) => m.FAIXA_ROUTES),
      },
      {
        path: 'solicitacao',
        loadChildren: () =>
          import('./main/solicitacao/solicitacao.routes').then(
            (m) => m.SOLICITACAO_ROUTES,
          ),
      },
      {
        path: 'programacao',
        loadChildren: () =>
          import('./main/programacao/programacao.routes').then(
            (m) => m.PROGRAMACAO_ROUTES,
          ),
      },
      {
        path: 'registro',
        loadChildren: () =>
          import('./main/registro/registro.routes').then(
            (m) => m.REGISTRO_ROUTES,
          ),
      },
      {
        path: 'contrato-zip',
        loadChildren: () =>
          import('./main/contrato-zip/contrato-zip.routes').then(
            (m) => m.CONTRATO_ZIP_ROUTES,
          ),
      },
      {
        path: 'relatorio',
        loadChildren: () =>
          import('./main/relatorio/relatorio.routes').then(
            (m) => m.RELATORIO_ROUTES,
          ),
      },
    ],
  },
  { path: 'error', component: AppErrorComponent },
  { path: 'login', component: AppLoginComponent },
  { path: '**', redirectTo: '/error' },
];
